import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../../../core/services/role.service';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { AppWindows } from '../../../../core/utils/app-windowsNew';
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-windows',
    templateUrl: './windows.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule],
    styleUrls: ['./windows.component.css']
})
export class WindowsComponent {
  windows:any[]=AppWindows
  spaces:any[]=[]
  windowsMenu:any[]=[]
  loading=false
  roleId:any
  role:any
  
  constructor(
    private roleService:RoleService,
    private toastrService:ToastrService,
    private route:ActivatedRoute,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }
  
  
     ngOnInit(){
      this.roleId=this.route.snapshot.paramMap.get('id')
      if(this.roleId) this.get()
        this.spaces=this.lsService.get(GlobalName.features).spaces

        
     }
     ngOnDestroy(){
      window.location.reload()
     }
  
  
     get(){
      this.roleService.get(this.roleId).subscribe((res:any)=>{
        this.role=res.data
  
          this.toastrService.success(res.message)
      },
      (err:any)=>{
          AppSweetAlert.simpleAlert("error","Configuration interface",err.error.message)
      })
     }
  
     store(){
      this.loading=true
      
      this.roleService.update(this.roleId,{
        windows:this.windowsMenu,
        name:this.role?.name
      }).subscribe((res:any)=>{
        this.loading=false
  
          this.toastrService.success(res.message)
  
      },
      (err:any)=>{
        this.loading=false
  
        console.log(err)
          AppSweetAlert.simpleAlert("error","Configuration interface",err.error.message)
      })
    }
  

    setWindows(ev:any){
      
      this.windowsMenu=this.windows.find((el:any)=> el.name ==ev)?.menus
      let allkeys:any[]=[]
      //let roleWindows=JSON.parse(this.role?.windows)
      let roleWindows=this.role?.windows

      roleWindows?.forEach((gt:any) => {
       if(gt.status) allkeys.push(gt.key)
        gt?.elements?.forEach((st:any) => {
          if(st.status) allkeys.push(st.key)
          if(st?.hasChildren){  st?.children?.forEach((c:any)=> {if(c.status) allkeys.push(c.key)});}
        })
      })
      console.log(allkeys)

      this.windowsMenu?.forEach((gt:any) => {
        if(allkeys.indexOf(gt?.key)!=-1)gt.status=true
        gt?.elements?.forEach((st:any) => {
          if(allkeys.indexOf(st?.key)!=-1)st.status=true
          if(st?.hasChildren){
           st?.children?.forEach((c:any) => { if(allkeys.indexOf(c?.key)!=-1)c.status=true});
          }
        });
      });
      console.log(this.windowsMenu)
    }
}
